import { useRecoilValue } from 'recoil';
import { useEffect, useRef, useState } from 'react';
import { currentFolderState, Folder } from '../store';
import useApiClient from '~/src/hooks/useApiClient';

const useParentFolder = () => {
  const currentFolder = useRecoilValue(currentFolderState);
  const apiClient = useApiClient();
  const [parentFolder, setParentFolder] = useState<Folder | null>(null);
  const [loading, setLoading] = useState(false);
  const lastFetchedParentIdRef = useRef<number | null>(null);

  useEffect(() => {
    const fetchParentFolder = async () => {
      const parentId = currentFolder?.parentFolderId ?? null;

      if (!parentId) {
        lastFetchedParentIdRef.current = null;
        setParentFolder(null);
        return;
      }

      // Prevent duplicate fetches for the same parent
      if (lastFetchedParentIdRef.current === parentId) {
        return;
      }

      lastFetchedParentIdRef.current = parentId;

      setLoading(true);
      try {
        const { data } = await apiClient.get<Folder>(`/folders/${parentId}`);
        setParentFolder(data);
      } catch {
        setParentFolder(null);
      } finally {
        setLoading(false);
      }
    };

    fetchParentFolder();
  }, [currentFolder?.parentFolderId, apiClient]);

  return { parentFolder, loading };
};

export default useParentFolder;
